module.exports = __webpack_public_path__ + "img/login_bg@3x.bd321705.png";